import PropTypes from 'prop-types';
import React from 'react';

import HeaderContainerGrid from '@/components/headerContainer/Grid';
import { ConfigureButton, HeaderActions, HeaderSeparator, ReportDatePicker, RunButton } from '@/components/reports/header';

const propTypes = {
  onClickFilter: PropTypes.func,
  onChangeDates: PropTypes.func,
  dates: PropTypes.object,
  sync: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default function OptoutSummaryHeader({ onClickFilter, onChangeDates, dates, sync, isLoading }) {
  return <>
    <HeaderContainerGrid title='Optout Summary Report'>
      <HeaderActions>
        <ReportDatePicker dates={dates} onChange={onChangeDates} />
        <HeaderSeparator />
        <ConfigureButton onClick={onClickFilter} />
        <RunButton isLoading={isLoading} disabled={isLoading} onClick={sync} />
      </HeaderActions>
    </HeaderContainerGrid>
  </>
}

OptoutSummaryHeader.propTypes = propTypes;
